import {FC, useCallback} from "react";
import Button, {ButtonProps} from "@memaro/components/Button.tsx";
import West from "@mui/icons-material/West";

type MoveLeftButtonProps = ButtonProps & {
    index: number,
    onClick: (index: number) => void
}

const MoveLeftButton: FC<MoveLeftButtonProps> = ({index, onClick, ...rest}) => {
    const handleClick = useCallback(() => onClick(index), [onClick, index])

    return (
        <Button onClick={handleClick} {...rest}>
            <West />
            <span>Foto naar voren plaatsen</span>
        </Button>
    )
}


export default MoveLeftButton
